import React, { Component } from 'react';
import { Image, Col, Form, Row, Modal, Container, Button } from 'react-bootstrap';

import Close from '../../../img/iconos/close.svg'

import './documents.css'

var h = window.innerHeight;
var w = window.innerWidth;

class HtmlModal extends Component {
  constructor(props){
    super(props)
  }

  render(){
    return(
      <Modal onHide={()=>this.props.close()} show={this.props.show}>
        <div style={{padding:15, maxHeight:(h-70), overflow:'scroll'}}>
          <div style={{textAlign:'right', marginBottom:15}}>
            <Image style={{height:20, cursor:'pointer'}} src={Close} onClick={()=>this.props.close()}/>
          </div>
          <div dangerouslySetInnerHTML={{__html:this.props.html}}/>
        </div>
      </Modal>
    )
  }
}
export default HtmlModal
